import { Component, ChangeDetectorRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TrackAttempts } from '@common/entities';
import { Utilities } from '@common/utils';

@Component({
  standalone: false,
  selector: 'common-verify-access-code',
  templateUrl: './verify-access-code.component.html',
  styleUrls: ['./verify-access-code.component.scss'],
})
export class VerifyAccessCodeComponent implements AfterViewInit {
  constructor(private cdr: ChangeDetectorRef) {}

  @Input() defaultErrorMessage = 'Invalid access code provided. Please try again.';
  @Input() lockOutMessage = 'You are temporarily locked out. Please try again later.';
  @Input() label = 'Access code';
  @Input() buttonText = 'Verify code';
  @Input() lockedOutUntil?: Date;
  @Output() verifyAccessCode = new EventEmitter();
  @Output() userLockOut = new EventEmitter();
  @Input() disableAccessCodeSubmit = false;

  itemFormCtrl = new FormControl('');
  accessCodeVerified = false;
  errorMessage = '';
  successMessage = '';
  defaultSuccessMessage = 'Congratulations, your access code has been verified!';
  initialized = false;

  ngAfterViewInit() {
    this.initialized = true;
  }

  verifyCode() {
    const trackAttempts = { lockedOutUntil: this.lockedOutUntil } as TrackAttempts;
    if (Utilities.isLockedOutTrackAttempts(trackAttempts)) {
      //if user is locked out
      this.accessCodeVerified = false;
      // this.errorMessage = this.lockOutMessage; //lockOutMessage should be set on the userLockOut event emitter
      this.successMessage = '';
      this.userLockOut.emit();
      this.cdr.detectChanges();
    } else {
      this.errorMessage = '';
      this.accessCodeVerified = false;
      const enteredCode = this.itemFormCtrl.value;
      this.verifyAccessCode.emit(enteredCode);
      this.cdr.detectChanges();
    }
  }

  verifyComplete(message?: string) {
    this.accessCodeVerified = true;
    this.errorMessage = '';
    this.successMessage = message ?? this.defaultSuccessMessage;
    this.cdr.detectChanges();
  }

  verifyInvalid(message?: string) {
    this.accessCodeVerified = false;
    this.errorMessage = message ?? this.defaultErrorMessage;
    this.successMessage = '';
    this.cdr.detectChanges();
  }

  clearErrorMessage(clearErrorMessage = true, clearLockoutMessage = true) {
    if (clearErrorMessage) {
      this.errorMessage = '';
    }
    if (clearLockoutMessage) {
      this.lockOutMessage = '';
    }
  }

  get displayErrorMessage() {
    let errMsg = this.errorMessage;
    const trackAttempts = { lockedOutUntil: this.lockedOutUntil } as TrackAttempts;
    if (Utilities.isLockedOutTrackAttempts(trackAttempts)) {
      errMsg = this.lockOutMessage;
    }
    return errMsg;
  }
}
